module.exports = __webpack_public_path__ + "static/media/cognizant.a3ce59a2.jpg";